import { Component, Prop, Vue } from "vue-property-decorator";
import IntervalTimer from "../interval_timer";
import { goToLogin } from "@/utils/router_helper";
import { LoginFromTypes } from "@/utils/router_helper/types";
@Component
class DialogLoginBtn extends Vue {
  @Prop()
  private ctx: any;
  @Prop()
  private user_name: any;
  private time = 5;

  private divStyle =
    "font-size: 16px;line-height: 22px;color: rgb(140,140,140);padding-bottom:20px;color:#fff;background:rgb(79,121,255);border-radius:8px;padding:10px 0;font-family:Avenir-Heavy;";
  private spanStyle = "";

  public render() {
    return (
      <div onClick={this.toLogin} style={this.divStyle}>
        OK <span style={this.spanStyle}>({this.time}s)</span>
      </div>
    );
  }

  private mounted() {
    this.setIntervalTime();
  }

  private setIntervalTime() {
    clearInterval(IntervalTimer.getTimer());
    const timer = setInterval(() => {
      IntervalTimer.setTimer(timer);
      --this.time;
      if (this.time <= 0) {
        this.toLogin();
      }
    }, 1000);
    IntervalTimer.setTimer(timer);
  }
  private toLogin() {
    goToLogin(LoginFromTypes.FREE_FOLLOW);
    this.ctx.isShow = false;
    clearInterval(IntervalTimer.getTimer());
  }
}

export default DialogLoginBtn;
